import React, { useContext, useEffect, useRef, useState } from "react";
import { MapboxContext } from "../maps/MapboxContext";

import BottomSheet from "../common/BottomSheet";
import StatusFilter from "./StatusFilter";
import TypeFilter from "./TypeFilter";
import { Box, Divider } from "@material-ui/core";

import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
  APPLIED,
  APPROVED,
  UNDER_CONSTRUCTION,
  CONSTRUCTED
} from "./constants";

export default React.memo(function Filters() {
  /**
   * Control point for filters.
   * When filters changes, create new accessors
   */

  const { setFilters } = useContext(MapboxContext);

  const { breakpoints } = useTheme();
  const isLarge = useMediaQuery(breakpoints.up("md"));

  /**
   * Status filter changes
   * This is hoisted because we have two separate instances of it.
   * Ideally, we'd create one instance of the component and move
   * it around with shared local state, but I'm not sure that's
   * possible.
   */
  const [statusFilter, setStatusFilter] = useState([
    APPLIED,
    APPROVED,
    UNDER_CONSTRUCTION,
    CONSTRUCTED
  ]);

  /**
   * track event in GA
   */
  useEffect(() => {
    window.gtag("event", "filter_buildings", {
      event_category: "engagement",
      event_label: statusFilter.join(",")
    });
  }, [statusFilter]);

  const divRef = useRef();

  return (
    <>
      {!isLarge && (
        <BottomSheet zIndex={10} overflowHeight={120} visible={!isLarge}>
          <StatusFilter
            value={statusFilter}
            setValue={setStatusFilter}
            setFilters={setFilters}
          />
        </BottomSheet>
      )}
      <Box
        ref={ref => (divRef.current = ref)}
        position={{ xs: "fixd", md: "absolute" }}
        zIndex={20}
        left={{ xs: 0, md: 16 }}
        top={{ xs: "auto", md: 42 }}
        bottom={{ xs: 0, md: "auto" }}
        pt={{ xs: 0, md: 3 }}
        bgcolor="white"
        width={{ xs: "100%", md: 380 }}
        boxShadow={{ xs: 0, md: 3 }}
        borderRadius={{ xs: 0, md: 10 }}
      >
        {isLarge && (
          <>
            <StatusFilter
              value={statusFilter}
              setValue={setStatusFilter}
              setFilters={setFilters}
            />
            <Divider light style={{ marginBottom: 56 }} />
          </>
        )}

        <TypeFilter setFilters={setFilters} />
      </Box>
    </>
  );
});
